<template>
  <ValidationProvider
    :rules="rules"
    v-slot="{ errors }"
    tag="div"
    class="checkbox-container"
  >
    <input
      type="checkbox"
      :value="value"
      v-model="toggleValue"
      :class="{ 'error': errors[0] }"
    />

    <div class="label-container" :class="{ 'error': errors[0] }">
      <slot name="label"/>
    </div>
  </ValidationProvider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate';

  export default {
    name: 'CustomCheckbox',

    data() {
      return {
        toggleValue: this.value
      };
    },

    props: {
      value: {
        type: [String, Boolean],
        default: false,
      },

      rules: {
        type: [Object, String],
        default: '',
      },
    },

    components: {
      ValidationProvider
    }
  };
</script>

<style lang="scss" scoped>
  .checkbox-container {
    display: flex;

    input {
      -webkit-appearance: none;
      -webkit-tap-highlight-color: transparent;
      position: relative;
      border: 0;
      outline: 0;
      cursor: pointer;

      &.error {
        &:before {
          border: 2px solid $red-color;
        }
      }

      &:before {
        content: "";
        display: block;
        width: 11px;
        height: 11px;
        border-radius: 3px;
        top: 0;
        left: 0;
        background: $white-color;
        border: 2px solid $second-color;
      }

      &:checked:before {
        content: "";
        display: block;
        width: 11px;
        height: 11px;
        border-radius: 3px;
        top: 0;
        left: 0;
        background: $second-color;
        border: 2px solid $second-color;
      }

      &:checked:after {
        content: "";
        display: block;
        width: 2px;
        height: 8px;
        border: solid $white-color;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        position: absolute;
        top: 2px;
        left: 6px;
      }
    }

    .label-container {
      margin-left: 0.5rem;
      margin-top: -2px;

      &.error {
        color: $red-color;
      }
    }
  }
</style>